
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/lexicon",
      function () {
        return require("private-next-pages/news/lexicon/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/lexicon"])
      });
    }
  